import { AppRoutingModule } from './../../app-routing.module';
import { AlertService } from './../../alert.service';
import { ApiService } from './../../api.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { ThemeService } from '../../theme.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  username: string;
	password: string;
	twoFactorCode: string;
	requiresTwoFactor: boolean = false;
	errorMessage: string;
	message: string;
  model: any = {};

  get loading() {
    return this.apiService.isLoading;
  }

  
  get logoUrl(): string {
    return this.themeSvc.logoUrl;
  }

  get logoAltText(): string {
    return this.themeSvc.logoAltText;
  }

  constructor(
    private apiService: ApiService,
    private alertService: AlertService,
    private router: Router,
    public themeSvc: ThemeService
  ) { }

  public viewNames = [];
  frontPageMessages = [];

  ngOnInit() {
    let request = this.apiService.getFrontPageMessages();
    request.setIsLoading = false;
    request.successFunc = x => this.frontPageMessages = x;
    request.ignoreErrors = true;
    request.start();
  }

  get isDevEnvironment() {
    return location.hostname === "localhost";
  }

  get showTestLogins() {
    return this.isDevEnvironment;
  }

  setView(viewName) {
    let request = this.apiService.selectView(viewName);
    request.successFunc = data => {
      if (data.success) {
        this.router.navigate(['']);
      }
      else {
        this.alertService.alert("Failed to select views");
      }
    };
    request.start();
  }

  doLogin() {
    this.doLoginx(this.model.username, this.model.password, this.model.twoFactorCode);
  }
  doLoginx(username, password, twoFactorCode) {
    let request = this.apiService.login(username, password, twoFactorCode);
    request.successFunc = data => {
      console.log('post login');
      if (data.success) {

        if (data.viewNames.length === 1) {
          this.setView(data.viewNames[0]);
        }
        else {
          this.viewNames = data.viewNames;
        }
      }
	  else if (data.requiresTwoFactor){
			this.requiresTwoFactor = true;
			this.message = data.message;
	  }
      else {
        this.alertService.alert("Login failed: " + data.reason);
      }
    };

    request.start();
  }
  
  cancelTwoFactor(){
	  this.requiresTwoFactor = false;
	  this.twoFactorCode = null;
	  this.password = null;
  }

  sanitize(html) {
    return html.replace(/\n/gi, "<br/>");
  }
}
